import { Skeleton } from './Skeleton'

function TableRowSkeleton() {
    return (
        <div className="grid h-[60px] w-full grid-cols-5 items-center justify-around border-b border-b-gray-300 bg-white py-1 last:rounded-b-lg last:border-b-0">
            {/* first row with avatar */}
            <div className="grid grid-cols-3 items-center gap-x-4 px-8">
                <Skeleton width={32} height={32} className="-mt-6" circle />
                <div className="col-span-2 pt-1">
                    <Skeleton className="col-span-2 inline-block h-4 w-2 rounded-lg" />
                </div>
            </div>

            {[2, 3, 4, 5].map((_, index) => (
                <div className="px-8 pt-1" key={index}>
                    <Skeleton className="h-4 w-2 rounded-lg" />
                </div>
            ))}
        </div>
    )
}

function TableHeaderSkeleton() {
    return (
        <div className="grid w-full grid-cols-5 justify-around rounded-t-lg bg-gray-100 py-[18px]">
            {[1, 2, 3, 4, 5].map((_, index) => (
                <div className="px-8" key={index}>
                    <Skeleton className="h-4 w-2 rounded-lg" />
                </div>
            ))}
        </div>
    )
}

export function TableSkeleton() {
    return (
        <div className="rounded-lg border border-gray-300">
            <TableHeaderSkeleton />
            {[1, 2, 3, 4, 5].map((_, index) => (
                <TableRowSkeleton key={index} />
            ))}
        </div>
    )
}
